import { render, staticRenderFns } from "./pipe-tos-confirm.vue?vue&type=template&id=1283618d&scoped=true"
import script from "./pipe-tos-confirm.vue?vue&type=script&lang=js"
export * from "./pipe-tos-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283618d",
  null
  
)

export default component.exports